import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareVersionDetailEmbedRoute: InvariantJiraRoute = {
	name: 'software-version-detail-embed',
	path: '/projects/:projectKey/versions/:versionId/tab/:tab/embed',
	exact: true,
};
